import React from 'react';
import NatGatewayInfo from '../NatGatewayInfo';
import AirgappedInfo from '../AirgappedInfo';

function InternetAccessStep({ state, setState }) {
  const handleInternetAccessChange = (requiresInternet) => {
    setState(prev => ({
      ...prev,
      requiresInternet,
      natGateways: requiresInternet ? (prev.drServer ? 2 : 1) : 0
    }));
  };

  return (
    <div className="space-y-6">
      <div className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Internet Access Requirements</h2>
        <p className="text-gray-600 mb-6">Select whether your solution requires internet access</p>
      </div>

      <div className="space-y-4">
        <div className="flex items-center p-4 border-2 border-gray-200 rounded-xl hover:bg-gray-50 cursor-pointer">
          <label className="flex items-center cursor-pointer w-full">
            <input
              type="radio"
              checked={state.requiresInternet}
              onChange={() => handleInternetAccessChange(true)}
              className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
            />
            <span className="ml-3 flex-grow">
              <span className="block text-lg font-medium text-gray-900">Internet Access Required</span>
              <span className="block text-sm text-gray-500">
                {state.drServer 
                  ? "Requires 2 NAT Gateways for high availability across both production and DR environments"
                  : "Requires 1 NAT Gateway for internet access"}
              </span>
            </span>
          </label>
          <NatGatewayInfo />
        </div>

        <div className="flex items-center p-4 border-2 border-gray-200 rounded-xl hover:bg-gray-50 cursor-pointer">
          <label className="flex items-center cursor-pointer w-full">
            <input
              type="radio"
              checked={!state.requiresInternet}
              onChange={() => handleInternetAccessChange(false)}
              className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
            />
                 <span className="ml-3 flex-grow">
              <span className="block text-lg font-medium text-gray-900">Airgapped Solution</span>
              <span className="block text-sm text-gray-500">
                No internet access required - connectivity will be through private VPN to customer premise only
              </span>
            </span>
          </label>
          <AirgappedInfo />
        </div>
      </div>
    </div>
  );
}

export default InternetAccessStep;